import {ClientSearchContent} from '/component/partial/reportCard/ClientSearchContent';
import EmptyReportContent from '/component/partial/reportCard/EmptyReportContent';
import ExpiringRewardsReportContent from '/component/partial/reportCard/ExpiringRewardsReportContent/ExpiringRewardsReportContent';
import ExpiringWellnessCreditsReportContent from '/component/partial/reportCard/ExpiringWellnessCreditsReportContent/ExpiringWellnessCreditsReportContent';
import NewClientsWithoutOrdersReportContent from '/component/partial/reportCard/NewClientsWithoutOrdersReportContent/NewClientsWithoutOrdersReportContent';
import OrderHistoryReportContent from '/component/partial/reportCard/OrderHistoryReportContent/OrderHistoryReportContent';
import PremierCancellationsReportContent from '/component/partial/reportCard/PremierCancellationsReportContent/PremierCancellationsReportContent';
import ProjectedPremierVolumeReportContent from '/component/partial/reportCard/ProjectedPremierVolumeReportContent/ProjectedPremierVolumeReportContent';
import {
  REPORT_CARD_CONTENT_EMPTY,
  REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS,
  REPORT_CARD_CONTENT_ORDER_HISTORY,
  REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS,
  REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME,
  REPORT_CARD_EXPIRING_REWARDS,
  REPORT_CARD_EXPIRING_WELLNESS,
  REPORT_CARD_INACTIVE_CLIENTS,
  SEARCH_CARD_CLIENT_CONTENT,
} from '/enum/reportCard.enum';

export const ALL_CONTENT = {
  [REPORT_CARD_CONTENT_ORDER_HISTORY]: OrderHistoryReportContent,
  [REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS]:
    PremierCancellationsReportContent,
  [REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME]:
    ProjectedPremierVolumeReportContent,
  [REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS]:
    NewClientsWithoutOrdersReportContent,
  [REPORT_CARD_INACTIVE_CLIENTS]: OrderHistoryReportContent,
  [REPORT_CARD_EXPIRING_WELLNESS]: ExpiringWellnessCreditsReportContent,
  [REPORT_CARD_EXPIRING_REWARDS]: ExpiringRewardsReportContent,
  [REPORT_CARD_CONTENT_EMPTY]: EmptyReportContent,
  [SEARCH_CARD_CLIENT_CONTENT]: ClientSearchContent,
};
